import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans } from 'react-i18next';
import { useToggleModalState } from './useModalState';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
    cursor: 'pointer',
  },
  questionBlock: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.marginBase * 2,
  },
  question: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
    flex: 1,
  },
  infoIcon: {
    fontSize: theme.iconSize.large,
    color: theme.colors.blue,
    marginRight: theme.marginBase * 2,
  },
  openCloseIcon: {
    fontSize: theme.iconSize.large,
    color: theme.colors.blue,
    marginLeft: theme.marginBase * 2,
    transition: 'transform .3s',
  },
  openCloseIconOpened: {
    transform: 'rotate(-180deg)',
  },
  answer: {
    ...theme.fonts.caption,
    overflow: 'hidden',
    color: theme.colors.inkSecondary,
    paddingRight: theme.marginBase * 2,
    marginLeft: theme.iconSize.regular + theme.marginBase * 4,

    transition: 'max-height .5s',
    maxHeight: 0,
  },
  spaceHolder: {
    height: theme.marginBase * 2,
  },
  answerOpened: {
    maxHeight: 500,
  },
}));

interface Props {
  question: string;
  answer?: string;
  children?: React.ReactNode;
}

const components = {
  a: <a />,
  br: <br />,
};

export const FAQItem = ({ question, answer, children }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const [opened, toggle] = useToggleModalState();

  return (
    <div className={classes.container} onClick={toggle}>
      <div className={classes.questionBlock}>
        <i className={classnames('ri-information-line', classes.infoIcon)} />

        <div className={classes.question}>
          <Trans i18nKey={question}>{question}</Trans>
        </div>

        <i
          className={classnames('ri-arrow-down-s-line', classes.openCloseIcon, {
            [classes.openCloseIconOpened]: opened,
          })}
        />
      </div>
      <div
        className={classnames(classes.answer, {
          [classes.answerOpened]: opened,
        })}
      >
        {children ? (
          children
        ) : (
          <Trans i18nKey={answer} components={components}>
            {answer}
          </Trans>
        )}
        <div className={classes.spaceHolder} />
      </div>
    </div>
  );
};
